export const language = [
  {
    id: 1,
    name: 'English',
  },
  {
    id: 2,
    name: 'Español - España (Spanish - Spain)',
  },
  {
    id: 3,
    name: 'Français (French)',
  },
  {
    id: 4,
    name: 'Italiano (Italian)',
  },
  {
    id: 5,
    name: 'Deutsch (German)',
  },
  {
    id: 6,
    name: 'Ελληνικά (Greek)',
  },
  {
    id: 7,
    name: '한국어 (Korean)',
  },
  {
    id: 8,
    name: '简体中文 (Simplified Chinese)',
  },
  {
    id: 9,
    name: '繁體中文 (Traditional Chinese)',
  },
  {
    id: 10,
    name: 'Русский (Russian)',
  },
  {
    id: 11,
    name: 'ไทย (Thai)',
  },
  {
    id: 12,
    name: '日本語 (Japanese)',
  },
  {
    id: 13,
    name: 'Português (Portuguese)',
  },
  {
    id: 14,
    name: 'Português - Brasil (Portuguese - Brazil)',
  },
  {
    id: 15,
    name: 'Polski (Polish)',
  },
  {
    id: 16,
    name: 'Dansk (Danish)',
  },
  {
    id: 17,
    name: 'Nederlands (Dutch)',
  },
  {
    id: 18,
    name: 'Suomi (Finnish)',
  },
  {
    id: 19,
    name: 'Norsk (Norwegian)',
  },
  {
    id: 20,
    name: 'Svenska (Swedish)',
  },
  {
    id: 21,
    name: 'Čeština (Czech)',
  },
  {
    id: 22,
    name: 'Magyar (Hungarian)',
  },
  {
    id: 23,
    name: 'Română (Romanian)',
  },
  {
    id: 24,
    name: 'Български (Bulgarian)',
  },
  {
    id: 25,
    name: 'Türkçe (Turkish)',
  },
  {
    id: 26,
    name: 'Українська (Ukrainian)',
  },
  {
    id: 27,
    name: 'Tiếng Việt (Vietnamese)',
  },
  {
    id: 28,
    name: 'Español - Latinoamérica (Spanish - Latin America)',
  },
]

export const newsBlogs = [
  {
    id: 10,
    date: 'August 11, 2022',
    title: 'Tickets for The International - Saturday, August 13',
    desc: `As the Arlington Major approaches its conclusion, more and more teams have now officially qualified to The International in Singapore this October.`,
    img: 'https://cdn.cloudflare.steamstatic.com/steamcommunity/public/images/clans/3703047/9c84f2a2182fab3130e45771f42655f40c6f5dd7.jpg',
  },
  {
    id: 9,
    date: 'August 11, 2022',
    title: "DOTA: Dragon's Blood Season 3 Released",
    desc: `Witness the thrilling conclusion to the battle for the Dota universe in the third season of DOTA: Dragon's Blood, now streaming on Netflix.`,
    img: 'https://cdn.cloudflare.steamstatic.com/steamcommunity/public/images/clans/3703047/b379c4ceb1ec82db9c1d01ea4c7f1765aea9e0dd.png',
  },
  {
    id: 8,
    date: 'August 3, 2022',
    title: 'The Arlington Major & The Road to the International',
    desc: `The Summer Tour of the DPC draws to a close, and The Arlington Major offers the best teams in the world a final chance at DPC points before the competitive road reaches The...`,
    img: 'https://cdn.cloudflare.steamstatic.com/steamcommunity/public/images/clans/3703047/17e3e74c5f323f431ec172c81940e81ad52588b3.jpg',
  },
  {
    id: 7,
    date: 'June 24, 2022',
    title: 'Dota 2 Short Film Contest',
    desc: `We're happy to announce that submissions are now open for this year's Dota 2 Short Film Contest. Filmmakers have until 3:00pm PDT on September 4, 2022 to submit their short film...`,
    img: 'https://cdn.cloudflare.steamstatic.com/steamcommunity/public/images/clans/3703047/05930771557c4c6b9815063975b6dbc18c1704a8.jpg',
  },
  {
    id: 6,
    date: 'June 21, 2022',
    title: 'Chest of Endless Days',
    desc: `Today's update introduces a treasure drop that features thirteen all-new item sets — the Chest of Endless Days.`,
    img: 'https://cdn.cloudflare.steamstatic.com/steamcommunity/public/images/clans/3703047/37974dcd7b699b864a8c8a21a79b5720443e0465.png',
  },
  {
    id: 5,
    date: 'June 21, 2022',
    title: 'Summer 2022 Workshop Call to Arms',
    desc: `Summer is just around the corner and now that the Battle Report Update is live, we're setting our sights on future releases.`,
    img: 'https://cdn.cloudflare.steamstatic.com/steamcommunity/public/images/clans/3703047/5b040beb9a647a5f51bb117794af3ffc16785b09.png',
  },
  {
    id: 4,
    date: 'November 23, 2021',
    title: 'DPC Winter 2022 Tour',
    desc: 'The first Tour of the next Dota Pro Circuit season kicks off next week and along with it comes season-long Fantasy play.',
    img: 'https://cdn.cloudflare.steamstatic.com/steamcommunity/public/images/clans/3703047/a0a77bacc56a9322f917cb1df60dcd680668bae8.png',
  },
  {
    id: 3,
    date: 'November 19, 2021',
    title: 'The Dota Pro Circuit 2021-2022 Winter Tour Qualifiers',
    desc: 'The year 2021 is winding down, but the next DPC season is just getting started. The Dota Pro Circuit 2021-2022 Season will officially kick off on November 29th, but the Division...',
    img: 'https://cdn.cloudflare.steamstatic.com/steamcommunity/public/images/clans/3703047/3ca505b93b80b42e87527d5bdaf446845ff8a0ea.png',
  },
  {
    id: 2,
    date: 'October 28, 2021',
    title: 'Marci Marches In',
    desc: 'New Hero, New Treasure and 7.30e Gameplay Update',
    img: 'https://cdn.cloudflare.steamstatic.com/steamcommunity/public/images/clans/3703047/e5a57f7b21063e63c40a4073903fe02560ebe95c.png',
  },
  {
    id: 1,
    date: 'October 16, 2021',
    title: 'This Fall Marci Joins the Fight',
    desc: "'For fans of DOTA: Dragon's Blood, the next hero joining the battle of the Ancients is already a familiar face.",
    img: 'https://cdn.cloudflare.steamstatic.com/steamcommunity/public/images/clans/3703047/aa9c5cc55358ebc6977e895d5d9c50ecaa718482.png',
  },
]

export const heroes = [
  {
    name: 'npc_dota_hero_antimage',
    id: 1,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_axe',
    id: 2,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_bane',
    id: 3,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_bloodseeker',
    id: 4,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_crystal_maiden',
    id: 5,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_drow_ranger',
    id: 6,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_earthshaker',
    id: 7,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_juggernaut',
    id: 8,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_mirana',
    id: 9,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_nevermore', //sf
    id: 11,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_morphling',
    id: 10,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_phantom_lancer',
    id: 12,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_puck',
    id: 13,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_pudge',
    id: 14,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_razor',
    id: 15,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_sand_king',
    id: 16,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_storm_spirit',
    id: 17,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_sven',
    id: 18,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_tiny',
    id: 19,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_vengefulspirit',
    id: 20,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_windrunner',
    id: 21,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_zuus',
    id: 22,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_kunkka',
    id: 23,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_lina',
    id: 25,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_lich',
    id: 31,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_lion',
    id: 26,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_shadow_shaman',
    id: 27,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_slardar',
    id: 28,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_tidehunter',
    id: 29,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_witch_doctor',
    id: 30,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_riki',
    id: 32,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_enigma',
    id: 33,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_tinker',
    id: 34,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_sniper',
    id: 35,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_necrolyte',
    id: 36,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_warlock',
    id: 37,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_beastmaster',
    id: 38,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_queenofpain',
    id: 39,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_venomancer',
    id: 40,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_faceless_void',
    id: 41,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_skeleton_king',
    id: 42,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_death_prophet',
    id: 43,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_phantom_assassin',
    id: 44,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_pugna',
    id: 45,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_templar_assassin',
    id: 46,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_viper',
    id: 47,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_luna',
    id: 48,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_dragon_knight',
    id: 49,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_dazzle',
    id: 50,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_rattletrap', // clock
    id: 51,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_leshrac',
    id: 52,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_furion', // np
    id: 53,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_life_stealer',
    id: 54,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_dark_seer',
    id: 55,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_clinkz',
    id: 56,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_omniknight',
    id: 57,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_enchantress',
    id: 58,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_huskar',
    id: 59,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_night_stalker',
    id: 60,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_broodmother',
    id: 61,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_bounty_hunter',
    id: 62,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_weaver',
    id: 63,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_jakiro',
    id: 64,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_batrider',
    id: 65,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_chen',
    id: 66,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_spectre',
    id: 67,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_doom_bringer',
    id: 69,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_ancient_apparition',
    id: 68,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_ursa',
    id: 70,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_spirit_breaker',
    id: 71,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_gyrocopter',
    id: 72,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_alchemist',
    id: 73,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_invoker',
    id: 74,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_silencer',
    id: 75,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_obsidian_destroyer',
    id: 76,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_lycan',
    id: 77,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_brewmaster',
    id: 78,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_shadow_demon',
    id: 79,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_lone_druid',
    id: 80,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_chaos_knight',
    id: 81,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_meepo',
    id: 82,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_treant',
    id: 83,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_ogre_magi',
    id: 84,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_undying',
    id: 85,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_rubick',
    id: 86,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_disruptor',
    id: 87,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_nyx_assassin',
    id: 88,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_naga_siren',
    id: 89,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_keeper_of_the_light',
    id: 90,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_wisp',
    id: 91,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_visage',
    id: 92,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_slark',
    id: 93,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_medusa',
    id: 94,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_troll_warlord',
    id: 95,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_centaur',
    id: 96,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_magnataur',
    id: 97,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_shredder',
    id: 98,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_bristleback',
    id: 99,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_tusk',
    id: 100,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_skywrath_mage',
    id: 101,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_abaddon',
    id: 102,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_elder_titan',
    id: 103,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_legion_commander',
    id: 104,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_ember_spirit',
    id: 106,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_earth_spirit',
    id: 107,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_terrorblade',
    id: 109,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_phoenix',
    id: 110,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_oracle',
    id: 111,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_techies',
    id: 105,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_winter_wyvern',
    id: 112,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_arc_warden',
    id: 113,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_abyssal_underlord',
    id: 108,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_monkey_king',
    id: 114,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_pangolier',
    id: 120,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_dark_willow',
    id: 119,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_grimstroke',
    id: 121,
    attribute: 'intelligence',
  },
  {
    name: 'npc_dota_hero_mars',
    id: 129,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_void_spirit',
    id: 126,
    attribute: 'agility',
  },
  {
    name: 'npc_dota_hero_snapfire',
    id: 128,
    attribute: 'strength',
  },
  {
    name: 'npc_dota_hero_hoodwink',
    id: 123,
    attribute: 'agility',
  },

  {
    name: 'npc_dota_hero_marci',
    id: 136,
    attribute: 'strength',
  },
]
